
<template>
    <li class="sidebar-item">
        <router-link 
            :to="getRoute()" 
            class="nav-link with-bullet" :title="category.name">
            
            <span v-if="hasChildren" class="caret" @click.prevent="toggleChildren(category.id)" :class="{'expand' : expand}">
                <fa :icon="['fas', expand ? 'caret-down' : 'caret-right']" fixed-width />
            </span>

            <span v-else style="width: 1.2rem"></span>

            <span class="text-truncate">{{ category.name }}</span>
            <span class="nav-badge">{{ category.components_count }}</span>
        </router-link>
        
        <ul v-if="hasChildren && expand" class="nav flex-column">
            <category-item v-for="(category) in children" :key="category.id" :category="category" :company="company" :is-sidebar="isSidebar" />
        </ul>
    </li>
</template>

<script>

import CategoryItem from '~/components/CategoryItem.vue';

export default {
    name: "category-item",
    components: {
        'category-item': CategoryItem
    },
    props: ['category','company','is-sidebar'],
    mounted: function() {
        this.isExpanded(this.category.id)
    },
    data: function() {
        return {
            children : this.category.children,
            expand : false
        };
    },
    computed : {
        hasChildren(){
            return this.category.children.length > 0;
        }
    },
    methods: {
        toggleChildren(id){
            this.expand = !this.expand;
            if(this.isSidebar){
                this.$store.dispatch('sidebar/setExpanded',{id:id});
            }
        },
        getRoute(){
            let route = {
                query: { 
                    category_id: this.category.id 
                }
            }
            
            if(this.isSidebar){
                route.path = '/components'
            }

            return route;
        },
        getCaret(){
            if(this.category.children.length > 0){
                return '';
            } else {
                return '';
            }
        },
        isExpanded(id){
            let expanded = this.$store.getters['sidebar/expanded'];
            this.expand = expanded.includes(id);
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CategoryItem.vue